module.exports = __webpack_public_path__ + "img/default_thumb.440081f7.png";